'use client';

import { useSystemLabels } from '@eliadmin/core/src/hooks/use-system-labels';
import Link from '@eliadmin/core/src/components/link';

import { CartBadge } from '@eliadmin/core/src/components/header/cart-badge';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { HEADER_CONFIG } from '@eliadmin/core/src/constants/header-config';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useCartQueryOpts } from '@eliadmin/core/src/hooks/cart/use-cart';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useQuery } from '@tanstack/react-query';

export type HeaderCartButtonProps = {
  className?: {
    root?: string;
    info?: string;
    title?: string;
    price?: string;
    badge?: string;
  };
};

export function HeaderCartButton({ className }: HeaderCartButtonProps) {
  const systemLabels = useSystemLabels();
  const me = useCustomerStore((state) => state.me);

  const { data: cart } = useQuery({ ...useCartQueryOpts(), enabled: !!me?.authToken });

  return (
    <Link aria-label={systemLabels('cart')} href={ROUTES.CART() ?? '#'} prefetch={true}>
      <Button
        asChild
        variant="outline"
        className={cn(
          'w-fit text-center',
          'relative flex h-10 w-10 items-center justify-center rounded-full border-none bg-white/20 p-0 transition-all hover:bg-white/25',
          'ea-cart-button',
          className?.root,
        )}
      >
        <div data-ea-visual-tag="button">
          <div className="relative flex h-5 w-5 items-center gap-1">
            {HEADER_CONFIG.headerMain.cart.icon}
            <CartBadge className={cn('h-5 w-5 bg-primary', className?.badge)} />
          </div>
        </div>
      </Button>
    </Link>
  );
}
